import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ObrasAdminGeral } from '../../models/obras-admin-geral.model';
import { ObrasAdminGeralService } from '../../services/obras-admin-geral.service';

@Component({
  selector: 'app-obras-admin-geral',
  templateUrl: './obras-admin-geral.component.html',
  styleUrls: ['./obras-admin-geral.component.scss']
})
export class ObrasAdminGeralComponent extends BaseFormComponent<ObrasAdminGeral> implements OnInit {

  constructor(
    private myServices: ObrasAdminGeralService,
    public activatedRoute: ActivatedRoute,
    public navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      qrcode_mode: new FormControl(this.entity?.qrcode_mode, [Validators.required]),
      qrcode_url: new FormControl(this.entity?.qrcode_url, [Validators.required]),
    });
  }

  getDataCreate(): ObrasAdminGeral {
    let data: ObrasAdminGeral;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar() {
    if (this.form.valid) {
      this.loading();
      this.myServices.updateGeral(this.getDataCreate()).subscribe({
        next: (res) => {
          this.loaded()
          this.msgSuccess('Cadastro alterado com sucesso!');
        },
        error: (error) => {
          this.loaded()
          this.msgError(error.error.message);
        },
      });
    } else {
      this.markAsDirty();
    }
  }
}
